import { render } from "./PlacementsConstraints.vue?vue&type=template&id=af845842"
import script from "./PlacementsConstraints.vue?vue&type=script&lang=js"
export * from "./PlacementsConstraints.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__